export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";